// 单文件引入方式

import Index from './Index.vue'

export default {
  install(Vue) {
    Vue.component('ZuiLicensePlateInput', Index)
  }
}
